(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nutragenix-shipping-notice"] && !Shopify.designMode) return;
  try {
    /*
    Stato in sessionStorage, chiave nutragenix:shipping-notice:<identificativo>.
    Vale per la sessione di questa scheda. Una scheda nuova, o il ripristino della sessione
    deciso dal browser, può mostrare di nuovo l’avviso: non c’è sincronizzazione tra schede.
    Se sessionStorage non è disponibile, un Set in memoria evita solo i doppioni nella pagina
    corrente. Un altro caricamento, anche nella stessa scheda, può mostrare di nuovo l’avviso.
  */
  const nutragenixShippingNoticeMemory = new Set();

  if (!customElements.get('nutragenix-shipping-notice')) {
    class NutragenixShippingNotice extends HTMLElement {
      static editorDismissed = false;

      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.dialog = this.querySelector('dialog');
        this.editor = this.dataset.editor === 'true' && window.Shopify && window.Shopify.designMode === true;
        this.noticeId = (this.dataset.noticeId || 'shipping-update-1').trim() || 'shipping-update-1';
        this.storageKey = 'nutragenix:shipping-notice:' + this.noticeId;
        this.opened = false;
        this.scrollLocked = false;
        this.watching = false;

        if (!this.dialog) return;
        if (this.editor && NutragenixShippingNotice.editorDismissed) return;
        if (!this.editor && this.wasSeen()) return;

        this.onDialogClick = (event) => {
          if (event.target === this.dialog) this.dialog.close();
        };
        this.onDialogClose = () => {
          this.unlockScroll();
          if (!this.removed) this.restoreFocus();
          if (this.editor && !this.removed && !this.closingFromCleanup) {
            NutragenixShippingNotice.editorDismissed = true;
          }
          document.removeEventListener('keydown', this.onEscape);
          this.unwatchOverlays();
        };
        this.onSupportClick = (event) => {
          const href = (event.currentTarget.getAttribute('href') || '').trim().toLowerCase();
          if (href.indexOf('javascript:') === 0 || href.indexOf('data:') === 0 || href.indexOf('vbscript:') === 0) {
            event.preventDefault();
            return;
          }
          this.remember();
        };
        this.onOverlayRelease = () => {
          if (!this.overlayBlocking()) this.tryOpen();
        };

        this.onEscape = (event) => {
          if (event.key !== 'Escape' || !this.dialog.open) return;
          this.dialog.close();
        };
        this.dialog.addEventListener('click', this.onDialogClick);
        this.dialog.addEventListener('close', this.onDialogClose);
        document.addEventListener('keydown', this.onEscape);
        this.querySelectorAll('[data-ngx-ship-close]').forEach((button) => {
          button.addEventListener('click', () => this.dialog.close());
        });
        this.querySelector('[data-ngx-ship-support]')?.addEventListener('click', this.onSupportClick);

        const delay = Number(this.dataset.delay);
        const wait = Number.isFinite(delay) ? delay : 1000;
        this.timer = window.setTimeout(() => this.tryOpen(), wait);
      }

      disconnectedCallback() {
        this.removed = true;
        window.clearTimeout(this.timer);
        if (this.onEscape) document.removeEventListener('keydown', this.onEscape);
        this.unwatchOverlays();
        this.unlockScroll();
        if (this.dialog && this.dialog.open) this.dialog.close();
      }

      tryOpen() {
        if (this.opened || !this.dialog || this.dialog.open) return;
        if (this.editor && NutragenixShippingNotice.editorDismissed) return;
        if (!this.editor && this.wasSeen()) return;
        if (this.overlayBlocking()) {
          this.watchOverlays();
          return;
        }
        this.unwatchOverlays();
        this.open();
      }

      open() {
        if (this.opened || this.dialog.open) return;
        const previous = document.activeElement;
        try {
          this.dialog.showModal();
        } catch (error) {
          this.unlockScroll();
          this.closeDialogQuietly();
          return;
        }

        this.previouslyFocused = previous;
        this.opened = true;

        try {
          this.lockScroll();
        } catch (error) {
          this.opened = false;
          this.unlockScroll();
          this.closeDialogQuietly();
          return;
        }

        if (!this.editor) this.remember();

        try {
          this.dialog.focus({ preventScroll: true });
        } catch (error) {
          this.dialog.focus();
        }
      }

      closeDialogQuietly() {
        if (!this.dialog || !this.dialog.open) return;
        this.closingFromCleanup = true;
        this.dialog.close();
        this.closingFromCleanup = false;
      }

      overlayBlocking() {
        if (document.querySelector('modal-dialog[open]')) return true;
        if (document.body.classList.contains('drawer--is-open')) return true;
        if (document.querySelector('quick-cart-drawer.is--open')) return true;
        if (this.privacyBannerVisible()) return true;
        return false;
      }

      privacyBannerVisible() {
        const nodes = document.querySelectorAll('#shopify-pc__banner, .shopify-pc__prefs__dialog');
        return Array.from(nodes).some((element) => {
          if (element.hidden || element.getAttribute('aria-hidden') === 'true') return false;
          const style = window.getComputedStyle(element);
          return style.display !== 'none' && style.visibility !== 'hidden';
        });
      }

      watchOverlays() {
        if (this.watching) {
          this.bindKnownOverlays();
          return;
        }
        this.watching = true;
        document.body.addEventListener('modalClosed', this.onOverlayRelease);
        this.quickCart = document.querySelector('quick-cart-drawer');
        this.quickCart?.addEventListener('closed', this.onOverlayRelease);
        this.observer = new MutationObserver(() => {
          this.bindKnownOverlays();
          this.onOverlayRelease();
        });
        this.observer.observe(document.body, {
          attributes: true,
          attributeFilter: ['class'],
          childList: true
        });
        this.observer.observe(document.documentElement, { childList: true });
        this.bindKnownOverlays();
      }

      bindKnownOverlays() {
        document.querySelectorAll('#shopify-pc__banner, .shopify-pc__prefs__dialog').forEach((dialog) => {
          if (dialog.dataset.ngxShipBound === 'true') return;
          dialog.dataset.ngxShipBound = 'true';
          dialog.addEventListener('close', this.onOverlayRelease);
          this.observer?.observe(dialog, {
            attributes: true,
            attributeFilter: ['open', 'class', 'hidden', 'style', 'aria-hidden']
          });
        });
      }

      unwatchOverlays() {
        if (!this.watching) return;
        this.watching = false;
        document.body.removeEventListener('modalClosed', this.onOverlayRelease);
        this.quickCart?.removeEventListener('closed', this.onOverlayRelease);
        this.observer?.disconnect();
        this.observer = null;
      }

      lockScroll() {
        if (this.scrollLocked) return;
        this.scrollLocked = true;
        if (window.bodyScrollLock && typeof window.bodyScrollLock.disableBodyScroll === 'function') {
          this.usedThemeLock = true;
          window.bodyScrollLock.disableBodyScroll(this.dialog, {
            allowTouchMove: (element) => this.dialog.contains(element)
          });
          return;
        }
        this.usedThemeLock = false;
        this.scrollSnapshot = {
          body: document.body.style.overflow,
          html: document.documentElement.style.overflow
        };
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
      }

      unlockScroll() {
        if (!this.scrollLocked) return;
        this.scrollLocked = false;
        if (this.usedThemeLock && window.bodyScrollLock && typeof window.bodyScrollLock.enableBodyScroll === 'function') {
          window.bodyScrollLock.enableBodyScroll(this.dialog);
          return;
        }
        if (this.scrollSnapshot) {
          document.body.style.overflow = this.scrollSnapshot.body;
          document.documentElement.style.overflow = this.scrollSnapshot.html;
          this.scrollSnapshot = null;
        }
      }

      restoreFocus() {
        const previous = this.previouslyFocused;
        this.previouslyFocused = null;
        if (!previous || previous === document.body || previous === document.documentElement) return;
        if (!previous.isConnected || typeof previous.focus !== 'function') return;
        try {
          previous.focus({ preventScroll: true });
        } catch (error) {
          previous.focus();
        }
      }

      wasSeen() {
        try {
          return window.sessionStorage.getItem(this.storageKey) === '1';
        } catch (error) {
          return nutragenixShippingNoticeMemory.has(this.storageKey);
        }
      }

      remember() {
        if (this.editor) return;
        try {
          window.sessionStorage.setItem(this.storageKey, '1');
        } catch (error) {
          nutragenixShippingNoticeMemory.add(this.storageKey);
        }
      }
    }

    customElements.define('nutragenix-shipping-notice', NutragenixShippingNotice);
  }
  } catch(e) { console.error(e); }
})();

})();
